import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import DataTable from 'react-data-table-component';
import { customTableStyles } from "../../utils";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import IdentifiesView from './ViewSide';
import IdentityFilter from './Filters';
const IdentifiesListPage = () => {
    // const navigate = useNavigate()
    const [isView, setIsView] = useState(false)
    const [isFilter, setIsFilter] = useState(false)
    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Password',
            selector: row => row.password,
            sortable: true,
        },
        {
            name: 'Address',
            selector: row => row.address,
            sortable: true,
        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: true,
        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: true,
        },
        {
            name: 'Metro Area',
            selector: row => row.metroArea,
            sortable: true,
        },
        {
            name: 'Real/Fake',
            selector: row => row.realOrFake,
            sortable: true,
        },
        {
            name: 'Added By',
            // selector: row => ,
            sortable: true,
            cell: (row) => (
                <span className='badge bg-info'>{row.addedBy}</span>
            ),
        },
        {
            name: 'Updated By',
            // selector: row => row.updatedBy,
            cell: (row) => (
                <span className='badge bg-info'>{row.updatedBy}</span>
            ),
            sortable: true,
        },
        {
            name: 'Created At',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated At',
            selector: row => row.updatedAt,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row) => (
                <>
                    <div className="hstack gap-1 fs-1">
                        <Button
                            aria-label="View"
                            onClick={() => setIsView(true)}
                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-eye-line" />
                        </Button>
                        <Link
                            aria-label="Edit"
                            to="/identifies/edit"
                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-edit-line" />
                        </Link>
                        <a
                            aria-label="Delete"
                            href="javascript:void(0);"
                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-delete-bin-7-line" />
                        </a>
                    </div>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const data = [
        {
            name: 'John Doe',
            email: 'john.doe@example.com',
            password: 'password123',
            address: '123 Main St',
            city: 'New York',
            state: 'NY',
            metroArea: 'Metro Area 1',
            realOrFake: 'Real',
            addedBy: 'Admin A',
            updatedBy: 'User A',
            createdAt: '2024-03-09T12:00:00',
            updatedAt: '2024-03-09T13:30:00',
        },
        {
            name: 'Jane Smith',
            email: 'jane.smith@example.com',
            password: 'password456',
            address: '456 Elm St',
            city: 'Los Angeles',
            state: 'CA',
            metroArea: 'Metro Area 2',
            realOrFake: 'Fake',
            addedBy: 'Admin B',
            updatedBy: 'User B',
            createdAt: '2024-03-08T10:30:00',
            updatedAt: '2024-03-09T09:15:00',
        },
        {
            name: 'Michael Johnson',
            email: 'michael.johnson@example.com',
            password: 'password789',
            address: '789 Oak St',
            city: 'Chicago',
            state: 'IL',
            metroArea: 'Metro Area 3',
            realOrFake: 'Real',
            addedBy: 'Admin C',
            updatedBy: 'User C',
            createdAt: '2024-03-07T15:45:00',
            updatedAt: '2024-03-08T14:20:00',
        },
        {
            name: 'Emily Davis',
            email: 'emily.davis@example.com',
            password: 'passwordabc',
            address: '101 Pine St',
            city: 'Houston',
            state: 'TX',
            metroArea: 'Metro Area 4',
            realOrFake: 'Fake',
            addedBy: 'Admin D',
            updatedBy: 'User D',
            createdAt: '2024-03-06T11:20:00',
            updatedAt: '2024-03-07T16:40:00',
        },
        {
            name: 'William Wilson',
            email: 'william.wilson@example.com',
            password: 'passworddef',
            address: '234 Maple St',
            city: 'Phoenix',
            state: 'AZ',
            metroArea: 'Metro Area 5',
            realOrFake: 'Real',
            addedBy: 'Admin E',
            updatedBy: 'User E',
            createdAt: '2024-03-05T09:10:00',
            updatedAt: '2024-03-06T10:25:00',
        },
        {
            name: 'Emma Brown',
            email: 'emma.brown@example.com',
            password: 'passwordghi',
            address: '567 Birch St',
            city: 'Philadelphia',
            state: 'PA',
            metroArea: 'Metro Area 6',
            realOrFake: 'Fake',
            addedBy: 'Admin F',
            updatedBy: 'User F',
            createdAt: '2024-03-04T14:30:00',
            updatedAt: '2024-03-05T11:55:00',
        },
        {
            name: 'Daniel Taylor',
            email: 'daniel.taylor@example.com',
            password: 'passwordjkl',
            address: '890 Cedar St',
            city: 'San Antonio',
            state: 'TX',
            metroArea: 'Metro Area 7',
            realOrFake: 'Real',
            addedBy: 'Admin G',
            updatedBy: 'User G',
            createdAt: '2024-03-03T08:45:00',
            updatedAt: '2024-03-04T17:30:00',
        },
        {
            name: 'Olivia Martinez',
            email: 'olivia.martinez@example.com',
            password: 'passwordmno',
            address: '111 Ash St',
            city: 'San Diego',
            state: 'CA',
            metroArea: 'Metro Area 8',
            realOrFake: 'Fake',
            addedBy: 'Admin H',
            updatedBy: 'User H',
            createdAt: '2024-03-02T10:00:00',
            updatedAt: '2024-03-03T12:20:00',
        },
        {
            name: 'Alexander Anderson',
            email: 'alexander.anderson@example.com',
            password: 'passwordpqr',
            address: '222 Walnut St',
            city: 'Dallas',
            state: 'TX',
            metroArea: 'Metro Area 9',
            realOrFake: 'Real',
            addedBy: 'Admin I',
            updatedBy: 'User I',
            createdAt: '2024-03-01T13:20:00',
            updatedAt: '2024-03-02T09:45:00',
        },
        {
            name: 'Sophia Garcia',
            email: 'sophia.garcia@example.com',
            password: 'passwordstu',
            address: '333 Pine St',
            city: 'San Jose',
            state: 'CA',
            metroArea: 'Metro Area 10',
            realOrFake: 'Fake',
            addedBy: 'Admin J',
            updatedBy: 'User J',
            createdAt: '2024-02-29T09:30:00',
            updatedAt: '2024-03-01T10:55:00',
        },
    ];
    return (
        <>
            <PageHeader name="Identities List" />


            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 ">
                                    <div className="col-auto p-0 d-flex gap-1">
                                        <Link to="/lead/import" className="btn btn-primary">
                                            Create Identities
                                        </Link>

                                    </div>
                                    <div className="col-auto p-0 ms-1">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => setIsFilter(true)}
                                        >
                                            <i className="ri-filter-2-fill" />
                                        </Button>
                                    </div>
                                    <div className="col-lg-3 col-auto p-0 ms-auto">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <IdentifiesView
                show={isView}
                close={() => setIsView(false)}
            />
            <IdentityFilter
                show={isFilter}
                close={() => setIsFilter(false)}
            />
        </>
    );
};

export default IdentifiesListPage;